import ctiSkillTracksLockup from '@/images/skilltracks/cti_skilltracks_lockup.png'

function SkillTracksComingSoonBanner() {
  return (
    <section
      aria-label="SkillTracks coming soon"
      className="mb-6 rounded-md border border-[#005DA8] bg-white px-4 py-5 sm:px-6 sm:py-6"
    >
      <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:gap-6">
        <img
          src={ctiSkillTracksLockup}
          alt="CTI SkillTracks"
          className="h-auto w-full max-w-md shrink-0 sm:max-w-xs md:max-w-sm"
        />
        <p className="text-grays-dark text-center text-sm font-medium leading-relaxed sm:text-left sm:text-base">
          Want to level up your tech&apos;s skills, but not exactly sure where to
          start? CTI SkillTracks builds a customized learning path for every
          technician based on technical skill assessments.
          <br />
          <span className="font-bold">Coming Fall 2026.</span>
        </p>
      </div>
    </section>
  )
}

export default SkillTracksComingSoonBanner
